// src/router/calendarioRoutes.js
export const calendarioRoutes = [
  {
    path: "/calendario",
    name: "calendario",
    component: () => import("@/views/CalendarioMarketingView.vue"),
    meta: {
      title: "Calendário de Marketing"
    }
  },
  {
    path: "/calendario/:slug",
    name: "DetalheEvento",
    component: () => import("@/views/calendario/DetalheEventoView.vue"),
    props: true, // envia o slug como prop
    meta: {
      title: "Detalhes do Evento"
    }
  },
];
